<script lang="ts">
  import Host from './screens/Host.svelte';
  import Join from './screens/Join.svelte';
  import SpotifyCallback from './display/SpotifyCallback.svelte';
  import HowToPlay from './shared/HowToPlay.svelte';
  import { resolveRole } from './lib/session';
  import { resolvePath } from './lib/route';

  const resolved = resolvePath(location.pathname);
  const route = resolved.route ?? resolveRole(location.search);
</script>

{#if route === 'callback'}
  <SpotifyCallback />
{:else if route === 'howto'}
  <HowToPlay />
{:else if route === 'join'}
  <Join code={resolved.code} />
{:else if route === 'display'}
  <Host />
{:else}
  <Join />
{/if}
